import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  CircularProgress,
  Button,
  Typography,
  Paper,
  Grid,
  Chip,
  Stack,
  Box,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Collapse,
  Card,
  CardContent,
  Divider,
  Container,
  Avatar
} from '@mui/material';
import {
  ArrowBack,
  Event,
  LocationOn,
  Description,
  Person,
  Phone,
  Email,
  Cake,
  CheckCircle,
  Warning,
  Paid,
  EventAvailable,
  EventBusy,
  CreditCard,
  CalendarToday,
  AttachMoney,
  AccountCircle,
  TextSnippetSharp,
  ExpandMore,
  ExpandLess
} from '@mui/icons-material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import Man2Icon from '@mui/icons-material/Man2';
import Woman2Icon from '@mui/icons-material/Woman2';
import ViewListIcon from '@mui/icons-material/ViewList';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { format, parseISO } from 'date-fns';
import EventDetailsEditor from './EventDetailsEditor';
import InfoIcon from '@mui/icons-material/Info';
import HttpsIcon from '@mui/icons-material/Https';

import { message } from 'antd';

import LoadingInformation from '../../Components/LoadingInformation';

function formatCurrency(value) {
  if (value === null || value === undefined) return 'RD$0.00';
  let numValue;
  if (typeof value === 'string') {
    numValue = parseFloat(value.replace(/,/g, ''));
  } else if (typeof value === 'number') {
    numValue = value;
  } else {
    return 'RD$0.00';
  }
  return numValue.toLocaleString('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const safeParseFloat = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(/,/g, ''));
    return isNaN(parsed) ? defaultValue : parsed;
  }
  return defaultValue;
};

const ViewEventDetails = ({ token, dressList, getDressListHandler, suitList, getSuitListHandler }) => {
  const { eventID } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editReservation, setEditReservation] = useState(false);
  const [editEvent, setEditEvent] = useState(false);
  const [editClient, setEditClient] = useState(false);
  const [editWeddingPartner, setEditWeddingPartner] = useState(false);
  const [editXV, setEditXV] = useState(false);
  const [editDude, setEditDude] = useState(false);
  const [editDress, setEditDress] = useState(false);
  const [editSuit, setEditSuit] = useState(false);
  const [dressReservations, setDressReservations] = useState([]);
  const [suitReservations, setSuitReservations] = useState([]);
  const [handleReqEventsError, setHandleReqEventsError] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const menuButtonRef = React.useRef(null);
  const [expandedSections, setExpandedSections] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [permissionError, setPermissionError] = useState(false);

  const open = Boolean(anchorEl);

  const checkPermissions = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    setPermissionError(false);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/users/check-modify-role-permissions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.status === 403) {
        messageApi.error('No tienes permisos para acceder a esta sección.');
        setPermissionError(true);
        throw new Error('No tienes permisos para acceder a esta sección.');
      }
    } catch (error) {
      messageApi.error(error.message || 'Error al verificar permisos.');
      throw error; // Re-throw to handle it in the calling function
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  const getDressReservations = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/list-dress-reservations', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error:', errorData.message);
        return setHandleReqEventsError(errorData.message);
      }
      const data = await response.json();
      return setDressReservations(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getSuitReservations = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/list-suit-reservations', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error:', errorData.message);
        return setHandleReqEventsError(errorData.message);
      }
      const data = await response.json();
      return setSuitReservations(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const fetchEventDetails = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch(`https://dprincess-training.servehttp.com/events/event-details/${eventID}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error('Error al cargar los detalles del evento');
      const data = await response.json();
      setEventData(data);
      setLoading(false);
    } catch (err) {
      setError('Error al cargar los detalles del evento');
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setEditReservation(false);
    setEditEvent(false);
    setEditClient(false);
    setEditWeddingPartner(false);
    setEditXV(false);
    setEditDress(false);
    setEditDude(false);
    setEditSuit(false);
  };

  const handleOpenDialog = (dialog) => {
    switch (dialog) {
      case 'reservation':
        setEditReservation(true);
        break;
      case 'event':
        setEditEvent(true);
        break;
      case 'client':
        setEditClient(true);
        break;
      case 'weddingpartner':
        setEditWeddingPartner(true);
        break;
      case 'xv':
        setEditXV(true);
        break;
      case 'dress':
        setEditDress(true);
        break;
      case 'birthdaydude':
        setEditDude(true);
        break;
      case 'suit':
        setEditSuit(true);
        break;
      default:
        break;
    }
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleSection = (sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  useEffect(() => {
    fetchEventDetails();
  }, []);

  useEffect(() => {
    getDressReservations();
    getSuitReservations();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "Fecha no disponible";
    try {
      return format(parseISO(dateString), "dd/MM/yyyy HH:mm");
    } catch (error) {
      return "Formato inválido";
    }
  };

  if (loading) return <LoadingInformation />;

  if (error) return (
    <Box sx={{ textAlign: 'center', mt: 4 }}>
      <Warning color="error" sx={{ fontSize: 60 }} />
      <Typography variant="h5" color="error" mt={2}>{error}</Typography>
    </Box>
  );

  if (eventData?.length === 0) return <Typography>Evento no encontrado</Typography>;

  // Componente para secciones responsivas
  const ResponsiveSection = ({
    title,
    icon,
    color,
    children,
    sectionKey,
    onEdit,
    extraActions,
    chipData
  }) => {
    const isExpanded = expandedSections[sectionKey];

    if (isMobile) {
      return (
        <Card elevation={2} sx={{ mb: 2, borderRadius: 3 }}>
          <CardContent sx={{ p: 2 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={() => toggleSection(sectionKey)}
            >
              <Typography variant="h6" sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: color,
                fontWeight: '600',
                fontSize: '1rem'
              }}>
                {icon}
                {title}
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {onEdit && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit();
                    }}
                  >
                    <EditOutlinedIcon sx={{ color: color, fontSize: 20 }} />
                  </IconButton>
                )}
                {/* Cambia aquí */}
                {extraActions && React.cloneElement(extraActions, {
                  onClick: (e) => {
                    e.stopPropagation();
                    if (extraActions.props.onClick) extraActions.props.onClick(e);
                  }
                })}
                <IconButton size="small">
                  {isExpanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
            </Box>

            {chipData && (
              <Box sx={{ mt: 1, mb: 1 }}>
                {chipData.map((chip, index) => (
                  <Chip
                    key={index}
                    icon={chip.icon}
                    label={chip.label}
                    color={chip.color}
                    size="small"
                    sx={{ mr: 1, mb: 1 }}
                  />
                ))}
              </Box>
            )}

            <Collapse in={isExpanded}>
              <Box sx={{ mt: 2 }}>
                <Divider sx={{ mb: 2 }} />
                {children}
              </Box>
            </Collapse>
          </CardContent>
        </Card>
      );
    }

    // Vista desktop/tablet
    return (
      <Paper elevation={2} sx={{
        p: 3,
        borderRadius: 3,
        borderLeft: '4px solid',
        borderColor: color,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2
        }}>
          <Typography variant="h6" sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: color,
            fontWeight: '600'
          }}>
            {icon}
            {title}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {onEdit && (
              <IconButton onClick={onEdit}>
                <Tooltip title={`Editar ${title.toLowerCase()}`}>
                  <EditOutlinedIcon sx={{ color: color, fontSize: 26 }} />
                </Tooltip>
              </IconButton>
            )}
            {extraActions}
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          {children}
        </Box>

        {chipData && (
          <Box sx={{ mt: 2 }}>
            {chipData.map((chip, index) => (
              <Chip
                key={index}
                icon={chip.icon}
                label={chip.label}
                color={chip.color}
                sx={{ mr: 1, mb: 1, px: 2 }}
              />
            ))}
          </Box>
        )}
      </Paper>
    );
  };

  if (permissionError) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        {contextHolder}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: '#f44336', width: 64, height: 64 }}>
            {/* Icono de candado para indicar acceso restringido */}
            <HttpsIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: '#f44336', fontWeight: 700 }}>
            No tienes permiso para acceder a esta sección
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'center' }}>
            Esta información solo está disponible para usuarios con permisos de administrador.
          </Typography>
        </Box>
      </Container>
    );
  };

  return (
    <Box sx={{
      p: isMobile ? 0 : 4,
      m: isMobile ? 0 : 2,
      borderRadius: 4,
      maxWidth: isMobile ? '100%' : 1100,
      width: '100%',
      bgcolor: '#f8f9fc',
      minHeight: '100vh',
      mx: 'auto'
    }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        variant="outlined"
        size={isMobile ? "small" : "medium"}
        sx={{
          mb: 3,
          color: '#f759ab',
          borderColor: '#f759ab',
          fontSize: isMobile ? '0.875rem' : '1rem',
          mt: isMobile && 3,
          ml: isMobile && 3
        }}
      >
        Volver
      </Button>

      <Grid container spacing={isMobile ? 2 : 4}>
        <Grid item xs={6}>
          <Typography
            variant={isMobile ? "h5" : "h4"}
            gutterBottom
            sx={{
              mb: 4,
              fontWeight: 'bold',
              color: '#f759ab',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexDirection: isMobile ? 'column' : 'row',
              textAlign: isMobile ? 'center' : 'left'
            }}
          >
            <Event fontSize={isMobile ? "medium" : "large"} />
            {eventData.event.eventTitle}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'right' }}>
            <IconButton title='Ver información de la factura' onClick={() => navigate(`/billing/invoice/${eventData.selectedServices[0].invoiceID}`)}>
              <InfoIcon />
            </IconButton>
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={isMobile ? 2 : 4} direction="column" alignItems="stretch">

        {/* Información de la reservación */}
        {eventData.reservation && (
          <Grid item xs={12}>
            <Paper elevation={2} sx={{
              p: 3,
              borderRadius: 3,
              borderLeft: '4px solid',
              borderColor: 'info.main',
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2
              }}>
                <Typography variant="h6" sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  color: 'info.main',
                  fontWeight: '600'
                }}>
                  <MenuBookIcon />
                  Información de la Reservación
                </Typography>
                <IconButton
                  id="menu-button"
                  ref={menuButtonRef}
                  onClick={e => {
                    e.stopPropagation();
                    handleMenuClick(e);
                  }}
                  sx={{ color: 'info.main' }}
                >
                  <Tooltip title="Más opciones">
                    <MoreVertIcon sx={{ color: 'info.main', fontSize: isMobile ? 24 : 30 }} />
                  </Tooltip>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: isMobile ? 'center' : 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: isMobile ? 'center' : 'right',
                  }}
                  disablePortal
                  sx={{
                    '& .MuiPaper-root': {
                      backgroundColor: 'rgb(232, 245, 255)',
                      borderRadius: 2,
                      boxShadow: '0 4px 6px rgba(0, 140, 255, 0.1)',
                      minWidth: 200,
                    }
                  }}
                >
                  <MenuItem
                    sx={{ color: 'info.main', py: 1.5, px: 2 }}
                    onClick={() => {
                      handleOpenDialog('reservation');
                      handleMenuClose();
                    }}
                  >
                    <EditOutlinedIcon sx={{ mr: 1.5, fontSize: 20 }} />
                    Editar Reservación
                  </MenuItem>
                  <MenuItem
                    sx={{ color: 'info.main', py: 1.5, px: 2 }}
                    onClick={() => {
                      handleMenuClose();
                      navigate(`/billing/invoice/${eventData.selectedServices[0].invoiceID}`);
                    }}
                  >
                    <TextSnippetSharp sx={{ mr: 1.5, fontSize: 20 }} />
                    Visualizar Factura
                  </MenuItem>
                </Menu>
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={isMobile ? 2 : 3}>
                  <DetailItem
                    icon={<AutoStoriesIcon sx={{ color: 'info.light' }} />}
                    label="Nombre del combo"
                    value={eventData.reservation.comboName}
                  />
                  {eventData.dresses?.shortDress && eventData.dresses.shortDress.map((dress, index) => (
                    <DetailItem key={index}
                      icon={<CheckroomIcon sx={{ color: 'info.light' }} />}
                      label="Vestido corto"
                      value={`${dress.code} - ${dress.dressName}`}
                    />
                  ))}
                  {eventData.dresses.longDress && eventData.dresses.longDress.map((dress, index) => (
                    <DetailItem key={index}
                      icon={<CheckroomIcon sx={{ color: 'info.light' }} />}
                      label="Vestido Largo"
                      value={`${dress.code} - ${dress.dressName}`}
                    />
                  ))}
                  {eventData?.suits && eventData.suits.map((suit, index) => (
                    <DetailItem key={index}
                      icon={<CheckroomIcon sx={{ color: 'info.light' }} />}
                      label="Traje"
                      value={`${suit.code} - ${suit.suitName}`}
                    />
                  ))}
                  <DetailItem
                    icon={<AttachMoney sx={{ color: 'info.light' }} />}
                    label="Precio del Combo"
                    value={`${formatCurrency(safeParseFloat(eventData.reservation.comboPrice) * ((100 - (eventData.reservation.discount || 0)) / 100))}`}
                  />
                  <DetailItem
                    icon={<AttachMoney sx={{ color: 'info.light' }} />}
                    label="Depósito Recibido"
                    value={`${formatCurrency(safeParseFloat(eventData.deposit.amount))}`}
                  />
                  <DetailItem
                    icon={<AttachMoney sx={{ color: 'info.light' }} />}
                    label="Total de servicios adicionales"
                    value={`${formatCurrency(safeParseFloat(eventData.reservation.servicesTotal))}`}
                  />
                  <DetailItem
                    icon={<AccountCircle sx={{ color: 'info.light' }} />}
                    label="¿Cómo nos conoció?"
                    value={(eventData.reservation?.referralSource?.charAt(0).toUpperCase() + eventData.reservation?.referralSource?.slice(1)) || 'Sistema'}
                  />
                  <DetailItem
                    icon={<AccountCircle sx={{ color: 'info.light' }} />}
                    label="Atendido Por"
                    value={eventData.employee?.employeeName || 'Sistema'}
                  />
                  <Grid item xs={12}>
                    <Box sx={{ m: 2, p: isMobile ? 2 : 3, backgroundColor: '#f1f3f5', borderRadius: 2 }}>
                      <Typography variant="body2" color="text.primary">
                        <strong>Nota:</strong> {eventData.reservation.notes || 'Sin observaciones registradas'}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ mt: 1, px: isMobile ? 2 : 3 }}>
                      <Chip
                        icon={<Paid sx={{ color: 'secondary.main' }} />}
                        label={`Pago: ${eventData.event.paymentStatus}`}
                        color={eventData.event.paymentStatus === 'completado' ? 'success' : 'error'}
                        size={isMobile ? "small" : "medium"}
                        sx={{ px: 2 }}
                      />
                    </Box>
                  </Grid>

                </Grid>
              </Box>
            </Paper>
          </Grid>
        )}

        {/* detalles del Evento */}
        <Grid item xs={12}>
          <ResponsiveSection
            title="Detalles del Evento"
            icon={<EventAvailable />}
            color="primary.main"
            sectionKey="event"
            onEdit={() => handleOpenDialog('event')}
            chipData={[
              {
                icon: <Paid sx={{ color: 'secondary.main' }} />,
                label: `Pago: ${eventData.event.paymentStatus}`,
                color: eventData.event.paymentStatus === 'completado' ? 'success' : 'error'
              }
            ]}
          >
            <Grid container spacing={isMobile ? 2 : 3}>
              <DetailItem
                icon={<Event sx={{ color: 'primary.light' }} />}
                label="Fecha de inicio"
                value={formatDate(eventData.event.eventDateStart)}
              />
              <DetailItem
                icon={<EventBusy sx={{ color: 'primary.light' }} />}
                label="Fecha de fin"
                value={formatDate(eventData.event.eventDateEnd)}
              />
              <DetailItem
                icon={<LocationOn sx={{ color: 'primary.light' }} />}
                label="Ubicación"
                value={eventData.event.eventLocation}
              />
              <DetailItem
                icon={<Description sx={{ color: 'primary.light' }} />}
                label="Descripción"
                value={eventData.event.eventDescription}
              />
              <DetailItem
                icon={<CalendarToday sx={{ color: 'primary.light' }} />}
                label='Tipo de evento'
                value={eventData.event.eventType == 'outside' ? 'Externo' : eventData.event.eventType == 'rental' ? 'Renta' : 'Interno'}
              />
            </Grid>
          </ResponsiveSection>
        </Grid>

        {/* Información del Cliente */}
        <Grid item xs={12}>
          <ResponsiveSection
            title="Información del Cliente"
            icon={<Person />}
            color="secondary.main"
            sectionKey="client"
            onEdit={() => handleOpenDialog('client')}
          >
            <Grid container spacing={isMobile ? 2 : 3}>
              <DetailItem
                icon={<Person sx={{ color: 'secondary.light' }} />}
                label="Nombre"
                value={eventData.client.clientName}
              />
              <DetailItem
                icon={<Email sx={{ color: 'secondary.light' }} />}
                label="Email"
                value={eventData.client.clientEmail}
              />
              <DetailItem
                icon={<Phone sx={{ color: 'secondary.light' }} />}
                label="Teléfono"
                value={eventData.client.phoneNumber}
              />
              <DetailItem
                icon={<Phone sx={{ color: 'secondary.light' }} />}
                label="Celular"
                value={eventData.client.cellphoneNumber}
              />
              <DetailItem
                icon={<LocationOn sx={{ color: 'secondary.light' }} />}
                label="Dirección"
                value={eventData.client.address}
              />
            </Grid>
          </ResponsiveSection>
        </Grid>

        {/* Detalles del/la novio/a */}
        {eventData.weddingpartner && (
          <Grid item xs={12}>
            <ResponsiveSection
              title="Pareja de Bodas"
              icon={<Cake />}
              color="success.main"
              sectionKey="weddingpartner"
              onEdit={() => handleOpenDialog('weddingpartner')}
            >
              <Grid container spacing={isMobile ? 2 : 3}>
                <DetailItem
                  icon={<Person sx={{ color: 'success.light' }} />}
                  label="Nombre"
                  value={eventData.weddingpartner.name}
                />
                <DetailItem
                  icon={<Email sx={{ color: 'success.light' }} />}
                  label="Email"
                  value={eventData.weddingpartner.wpEmail}
                />
                <DetailItem
                  icon={<Phone sx={{ color: 'success.light' }} />}
                  label="Celular"
                  value={eventData.weddingpartner.wpCellphoneNumber}
                />
              </Grid>
            </ResponsiveSection>
          </Grid>
        )}

        {/* Detalles de la Quinceañera */}
        {eventData.XV && eventData.XV.XVID > 1 && (
          <Grid item xs={12}>
            <ResponsiveSection
              title="Detalles de la Quinceañera"
              icon={<Cake />}
              color="warning.main"
              sectionKey="xv"
              onEdit={() => handleOpenDialog('xv')}
            >
              <Grid container spacing={isMobile ? 2 : 3}>
                <DetailItem
                  icon={<Person sx={{ color: 'warning.light' }} />}
                  label="Nombre"
                  value={eventData.XV.XVName}
                />
                <DetailItem
                  icon={<Phone sx={{ color: 'warning.light' }} />}
                  label="Celular"
                  value={eventData.XV.XVCellphoneNumber || 'N/A'}
                />
                <DetailItem
                  icon={<Email sx={{ color: 'warning.light' }} />}
                  label="Email"
                  value={eventData.XV.XVEmail || 'N/A'}
                />
                <DetailItem
                  icon={<Cake sx={{ color: 'warning.light' }} />}
                  label="Cumpleaños"
                  value={format(parseISO(eventData.XV.birthday), 'dd/MM/yyyy')}
                />
              </Grid>
            </ResponsiveSection>
          </Grid>
        )}

        {/* Detalles del Cumpleañero/a */}
        {eventData.birthdaydude && (
          <Grid item xs={12}>
            <ResponsiveSection
              title="Cumpleañero/a"
              icon={<Cake />}
              color="success.main"
              sectionKey="birthdaydude"
              onEdit={() => handleOpenDialog('birthdaydude')}
            >
              <Grid container spacing={isMobile ? 2 : 3}>
                <DetailItem
                  icon={<Person sx={{ color: 'success.light' }} />}
                  label="Nombre"
                  value={eventData.birthdaydude.name}
                />
                <DetailItem
                  icon={<Email sx={{ color: 'success.light' }} />}
                  label="Email"
                  value={eventData.birthdaydude.email}
                />
                <DetailItem
                  icon={<Phone sx={{ color: 'success.light' }} />}
                  label="Celular"
                  value={eventData.birthdaydude.cellphoneNumber}
                />
                <DetailItem
                  icon={<Cake sx={{ color: 'success.light' }} />}
                  label="Cumpleaños"
                  value={format(parseISO(eventData.birthdaydude.birthday), 'dd/MM/yyyy')}
                />
              </Grid>
            </ResponsiveSection>
          </Grid>
        )}

        {/* Información de los vestidos rentados*/}
        {eventData.dresses && (
          <Grid item xs={12}>
            <ResponsiveSection
              title="Información de los Vestidos"
              icon={<Woman2Icon />}
              color="#f759ab"
              sectionKey="dresses"
              onEdit={() => handleOpenDialog('dress')}
            >
              <Grid container spacing={isMobile ? 2 : 3}>
                {/* Filter dresses by type */}
                {/* Short dresses for XV */}
                {eventData.dresses?.shortDress && eventData.dresses.shortDress.map((dress, index) => (
                  (dress.dressName !== 'No aplica' && dress.dressType === "xv") &&
                  (<DetailItem key={index}
                    icon={<CheckroomIcon sx={{ color: '#f759ab' }} />}
                    label="Vestido corto de quinceañera"
                    value={`${dress.code} - ${dress.dressName}`}
                  />)
                ))}
                {/* Long dresses for XV */}
                {eventData.dresses.longDress && eventData.dresses.longDress.map((dress, index) => (
                  (dress.dressName !== 'No aplica' && dress.dressType === "xv") &&
                  (<DetailItem key={index}
                    icon={<CheckroomIcon sx={{ color: '#f759ab' }} />}
                    label="Vestido largo de quinceañera"
                    value={`${dress.code} - ${dress.dressName}`}
                  />)
                ))}
                {/* Dresses for wedding */}
                {eventData.dresses.longDress && eventData.dresses.longDress.map((dress, index) => (
                  (dress.dressName !== 'No aplica' && dress.dressType === "wedding") &&
                  (
                    <DetailItem key={index}
                      icon={<CheckroomIcon sx={{ color: '#f759ab' }} />}
                      label="Vestido de novia"
                      value={`${dress.code} - ${dress.dressName}`}
                    />
                  )
                ))}
              </Grid>
            </ResponsiveSection>
          </Grid>
        )}

        {/* Información de los trajes rentados*/}
        {(eventData.suits) && (
          <Grid item xs={12}>
            <ResponsiveSection
              title="Información de los Trajes"
              icon={<Man2Icon />}
              color="info.main"
              sectionKey="suits"
              onEdit={() => handleOpenDialog('suit')}
            >
              <Grid container spacing={isMobile ? 2 : 3}>
                {eventData.suits && eventData.suits.map((suit, index) => (
                  (suit.suitName !== 'No aplica') &&
                  (<DetailItem key={index}
                    icon={<CheckroomIcon sx={{ color: 'info.light' }} />}
                    label={suit.suitName}
                    value={`${suit.code} - ${suit.suitName}`}
                  />)
                ))}
              </Grid>
            </ResponsiveSection>
          </Grid>
        )}

        {/* Información de los servicios */}
        {eventData.selectedServices && eventData.selectedServices.length > 0 && (
          <Grid item xs={12}>
            <ResponsiveSection
              title="Servicios Adicionales"
              icon={<MenuBookIcon />}
              color="info.main"
              sectionKey="services"
              extraActions={
                <IconButton onClick={() => navigate(`/billing/invoice/${eventData.selectedServices[0].invoiceID}`)}>
                  <Tooltip title="Visualizar detalles de la factura">
                    <ViewListIcon sx={{ color: 'info.main', fontSize: isMobile ? 24 : 26 }} />
                  </Tooltip>
                </IconButton>
              }
            >
              <Grid container spacing={isMobile ? 2 : 3}>
                {eventData.selectedServices
                  .filter(service => service.serviceID && service.serviceID !== 24) // Filtrar servicios con serviceID definido y diferente de 24
                  .map((service, index) => (
                    <DetailItem key={index}
                      icon={<InfoIcon sx={{ color: 'info.light' }} />}
                      label="Servicio"
                      value={service.serviceQty + " x " + service.serviceName}
                    />
                  ))}
              </Grid>
            </ResponsiveSection>
          </Grid>
        )}

      </Grid>
      {/* Edit Dialogs */}
      <EventDetailsEditor eventsDetails={eventData} editClient={editClient} editEvent={editEvent} handleCloseDialog={handleCloseDialog}
        editReservation={editReservation} editWeddingPartner={editWeddingPartner} editXV={editXV} dressReservations={dressReservations}
        getDressReservations={getDressReservations} handleReqEventsError={handleReqEventsError} getDressListHandler={getDressListHandler}
        suitList={suitList} getSuitListHandler={getSuitListHandler} handleOpenDialog={handleOpenDialog} fetchEventDetails={fetchEventDetails}
        editDress={editDress} dressList={dressList} editDude={editDude} editSuit={editSuit} suitReservations={suitReservations}
      />
    </Box>
  );
};

const DetailItem = ({ icon, label, value }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid item xs={12} sm={6}>
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={isMobile ? 1 : 2}
        alignItems={isMobile ? "flex-start" : "center"}
        sx={{
          p: isMobile ? 1.5 : 2,
          borderRadius: 2,
          bgcolor: 'rgba(0,0,0,0.02)',
          border: '1px solid rgba(0,0,0,0.05)'
        }}
      >
        <Box sx={{
          width: isMobile ? 'auto' : 40,
          display: 'flex',
          justifyContent: isMobile ? 'flex-start' : 'center',
          alignItems: 'center',
          mb: isMobile ? 0.5 : 0
        }}>
          {icon}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{
              fontSize: isMobile ? '0.75rem' : '0.875rem',
              mb: 0.5
            }}
          >
            {label}
          </Typography>
          <Typography
            variant="body1"
            fontWeight="500"
            sx={{
              fontSize: isMobile ? '0.875rem' : '1rem',
              wordBreak: 'break-word'
            }}
          >
            {value || 'N/A'}
          </Typography>
        </Box>
      </Stack>
    </Grid>
  );
};



export default ViewEventDetails;